import React from "react";

const Chapter2 = () => {
  return (
    <>
      <h2>What are Contaminants of Emerging Concern (CECs)?</h2>
      <p>
        Contaminants of Emerging Concern (CECs) are a broad classification of
        human-made chemicals or other agents that have either been recently
        found in the environment or that present new concerns based on improved
        scientific understanding. Pesticides (used to kill insects, rodents or
        plants), consumer products such as plastics, over the counter or
        prescription medications, personal care products, such as cosmetics,
        hair care products, antiperspirants, body washes, or skin moisturizers
        are examples of products people use that contain CECs. The chemicals in
        these products are increasingly being detected as low concentration
        complex mixtures in rivers, streams, lakes, and groundwater. For an
        example of CEC effects, some of these chemicals may be “endocrine
        disruptors” which interfere with animals’ (including people) internal
        chemical messenger system which controls growth and reproduction.
        Endocrine disruptors can exert effects at very low concentrations in the
        environment and there is evidence that these chemicals can harm aquatic
        life such as fish or aquatic insects. At this time, very little
        information is known about potential effects on human health. There are
        currently no water quality standards for most CECs. However, the EPA
        White Paper Aquatic Life Criteria for Contaminants of Emerging Concern:
        Part I Challenges and Recommendations should enable the Agency to better
        address CECs and develop appropriate water quality standards for the
        protection of aquatic life using the best available science.
      </p>
    </>
  );
};

export default Chapter2;
